import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "max-w-7xl mx-auto p-8" };
const _hoisted_2 = { class: "grid grid-cols-12 mb-4" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-2 text-right",
    for: "school_name"
}, " 学校名： ", -1);
const _hoisted_4 = { class: "col-span-8" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "grid grid-cols-12 mb-4" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-2 text-right",
    for: "examination_title"
}, " 模試名： ", -1);
const _hoisted_8 = { class: "col-span-8" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "grid grid-cols-12 mb-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-2 text-right",
    for: "examination_type"
}, " 模試種別： ", -1);
const _hoisted_12 = { class: "col-span-8" };
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "flex ml-8 mb-5" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", {
    class: "block font-medium text-gray-700",
    for: "isLinkedStudentDataOnly"
}, " 連携済み学生以外のデータを読み込まない ", -1);
const _hoisted_16 = { class: "ml-8 mb-5" };
const _hoisted_17 = {
    method: "post",
    enctype: "multipart/form-data"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
    key: 0,
    class: "pt-2 pl-6"
};
const _hoisted_20 = {
    key: 0,
    class: "mb-5 ml-8"
};
const _hoisted_21 = ["disabled", "onClick"];
const _hoisted_22 = { class: "mb-8 ml-8 flex" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-1 text-center" }, " 選択した学校と選択した模試の全模試種別を対象に集計を行います。 ", -1);
const _hoisted_24 = ["disabled", "onClick"];
const _hoisted_25 = {
    key: 1,
    class: "ml-8 mb-6"
};
const _hoisted_26 = {
    key: 2,
    class: "ml-8 mb-6"
};
const _hoisted_27 = {
    key: 3,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_28 = { class: "col-span-4 flex items-center" };
const _hoisted_29 = { class: "mx-auto py-3 px-2 col-span-4 block bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_30 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_31 = {
    key: 4,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_32 = { class: "col-span-4 flex items-center" };
const _hoisted_33 = { class: "mx-auto py-3 px-2 block col-span-4 bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_34 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_35 = {
    key: 5,
    class: "ml-8 mb-4 grid grid-cols-12"
};
const _hoisted_36 = { class: "col-span-4 flex items-center" };
const _hoisted_37 = { class: "mx-auto py-3 px-2 block col-span-4 bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_38 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
const _hoisted_39 = {
    key: 6,
    class: "ml-8 grid grid-cols-12"
};
const _hoisted_40 = { class: "col-span-4 flex items-center" };
const _hoisted_41 = { class: "mx-auto py-3 px-2 block col-span-4 bg-red-600 hover:shadow-lg text-white rounded" };
const _hoisted_42 = /*#__PURE__*/ _createTextVNode(" CSVデータ出力 ");
import { ref, computed, reactive, } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import 'smart-tagz/dist/smart-tagz.css';
import DownloadCsv from 'vue-json-csv';
import Swal from 'sweetalert2';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        schools: {
            type: Object,
            default: () => ({}),
        },
        examinations: {
            type: Array,
            default: () => [],
        },
        examinationTypes: {
            type: Object,
            default: () => ({}),
        },
        selectedSchoolId: {
            type: Number,
            default: 0,
        },
        selectedExaminationId: {
            type: Number,
            default: 0,
        },
        selectedExaminationType: {
            type: Number,
            default: 0,
        },
        isSelectedLinkedStudentDataOnly: {
            type: Boolean,
            default: true,
        },
        notExistentUsersData: {
            type: Object,
            default: () => ({}),
        },
        answerRegisteredUsersData: {
            type: Object,
            default: () => ({}),
        },
        sameIdUsersData: {
            type: Object,
            default: () => ({}),
        },
        notStudentUsersData: {
            type: Object,
            default: () => ({}),
        },
        csvLabels: {
            type: Array,
            default: () => [],
        },
        registeredUserCount: {
            type: Number,
            default: 0,
        },
    },
    setup(__props) {
        const props = __props;
        const refCsvFile = ref();
        const csvFileNamePreview = ref();
        const isProcessing = ref(false);
        const hasCsvFile = computed(() => !!csvFileNamePreview.value);
        const { csvLabels } = props;
        const NotExistentUserFileName = computed(() => `nonExistentUser_${props.examinations[props.selectedExaminationId - 1].title}_${props.examinationTypes[props.selectedExaminationType]}.csv`);
        const answerRegisteredUserFileName = computed(() => `answerRegisteredUser_${props.examinations[props.selectedExaminationId].title}_${props.examinationTypes[props.selectedExaminationType]}.csv`);
        const sameIdUserFileName = computed(() => `sameIdUser_${props.examinations[props.selectedExaminationId].title}_${props.examinationTypes[props.selectedExaminationType]}.csv`);
        const notStudentUserFileName = computed(() => `notStudentUser_${props.examinations[props.selectedExaminationId].title}_${props.examinationTypes[props.selectedExaminationType]}.csv`);
        const getNotExistentUsersData = computed(() => {
            const csvData = [];
            props.notExistentUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getAnswerRegisteredUsersData = computed(() => {
            const csvData = [];
            props.answerRegisteredUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getSameIdUsersData = computed(() => {
            const csvData = [];
            props.sameIdUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const getNotStudentUsersData = computed(() => {
            const csvData = [];
            props.notStudentUsersData.forEach((userData) => {
                csvData.push(userData);
            });
            return csvData;
        });
        const form = reactive(Inertia.form({
            schoolId: props.selectedSchoolId,
            examinationId: props.selectedExaminationId,
            examinationType: props.selectedExaminationType,
            isLinkedStudentDataOnly: props.isSelectedLinkedStudentDataOnly,
            csvFile: '',
            csvFileName: '',
        }));
        const messages = reactive({
            examInfo: {
                errors: [''],
            },
            schoolInfo: {
                errors: [''],
            },
        });
        const onFileChanged = (e) => {
            csvFileNamePreview.value = e.target.files[0].name;
            form.csvFileName = e.target.files[0].name;
            form.csvFile = refCsvFile.value?.files?.[0];
            isProcessing.value = false;
        };
        const openFileView = (event) => {
            refCsvFile?.value?.click();
        };
        const onSubmitted = async () => {
            messages.examInfo.errors = [];
            isProcessing.value = true;
            if (!(form.examinationType && form.examinationId)) {
                messages.examInfo.errors.push('模試情報を選択してください。');
                isProcessing.value = false;
                return;
            }
            if (await isIncludeNotSelectedExam()) {
                Swal.fire({
                    icon: 'question',
                    html: `ファイル名に選択した模試種別と<br>異なる模試種別名が含まれています。<br>ファイルの読み込みを続行しますか？<br><br>ファイル名：${csvFileNamePreview.value}<br>選択模試種別：${props.examinationTypes[form.examinationType]}`,
                    showCancelButton: true,
                    confirmButtonText: 'はい',
                    cancelButtonText: 'いいえ',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await form.post(route('school.import'), {
                            onSuccess: () => {
                                isProcessing.value = false;
                                refCsvFile.value = '';
                                form.CsvFile = '';
                                form.csvFileName = '';
                            },
                        });
                        return;
                    }
                    isProcessing.value = false;
                }).catch((e) => {
                    Swal.fire({
                        text: e.code,
                        icon: 'error',
                        confirmButtonText: '閉じる',
                    });
                    isProcessing.value = false;
                });
            }
            else {
                await form.post(route('school.import'), {
                    onSuccess: () => {
                        isProcessing.value = false;
                        refCsvFile.value = '';
                        form.CsvFile = '';
                        form.csvFileName = '';
                    },
                });
                return;
            }
            isProcessing.value = false;
        };
        const onClickedSetScoreButton = () => {
            isProcessing.value = true;
            messages.schoolInfo.errors = [];
            if (!form.schoolId) {
                messages.schoolInfo.errors.push('学校名を選択してください。');
                isProcessing.value = false;
                return;
            }
            if (!form.examinationId) {
                messages.schoolInfo.errors.push('模試名を選択してください。');
                isProcessing.value = false;
                return;
            }
            form.post(route('school.set-score'), {
                onSuccess: () => {
                    isProcessing.value = false;
                },
            });
        };
        const isIncludeNotSelectedExam = () => {
            let notSelectedExams;
            switch (Number(form.examinationType)) {
                case 1:
                    notSelectedExams = /一般|実地/;
                    break;
                case 2:
                    notSelectedExams = /必須|実地/;
                    break;
                case 3:
                    notSelectedExams = /必須|一般/;
                    break;
                default:
                    return false;
            }
            return notSelectedExams.test(csvFileNamePreview.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("select", {
                            id: "school_name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).schoolId) = $event)),
                            class: "border border-gray-300 outline-none rounded-md bg-white placeholder-gray-400 text-gray-500 focus:outline-none"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schools, (school) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: school.id,
                                    value: school.id
                                }, _toDisplayString(school.name), 9, _hoisted_5));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _unref(form).schoolId]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("select", {
                            id: "examination_title",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).examinationId) = $event)),
                            class: _normalizeClass([{ 'bg-red-100': !!_unref(form).errors.field_name }, "border border-gray-300 outline-none rounded-md bg-white placeholder-gray-400 text-gray-500 focus:outline-none"])
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.examinations, (examination) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: examination.id,
                                    value: examination.id
                                }, _toDisplayString(examination.title), 9, _hoisted_9));
                            }), 128))
                        ], 2), [
                            [_vModelSelect, _unref(form).examinationId]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("select", {
                            id: "examination_type",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).examinationType) = $event)),
                            class: "border border-gray-300 outline-none rounded-md bg-white placeholder-gray-400 text-gray-500 focus:outline-none"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.examinationTypes, (examinationType, i) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: i,
                                    value: i
                                }, _toDisplayString(examinationType), 9, _hoisted_13));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _unref(form).examinationType]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                        id: "isLinkedStudentDataOnly",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).isLinkedStudentDataOnly) = $event)),
                        type: "checkbox",
                        class: "h-5 w-5 mr-3 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50",
                        autofocus: ""
                    }, null, 512), [
                        [_vModelCheckbox, _unref(form).isLinkedStudentDataOnly]
                    ]),
                    _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("form", _hoisted_17, [
                        _createElementVNode("input", {
                            ref: (_value, _refs) => {
                                _refs['refCsvFile'] = _value;
                                refCsvFile.value = _value;
                            },
                            type: "file",
                            accept: ".csv",
                            class: "hidden",
                            onChange: onFileChanged
                        }, null, 544),
                        _createElementVNode("button", {
                            class: "px-4 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                            name: "image_url_commentary",
                            onClick: _withModifiers(openFileView, ["prevent"])
                        }, " ファイル選択 ", 8, _hoisted_18),
                        (_unref(hasCsvFile))
                            ? (_openBlock(), _createElementBlock("label", _hoisted_19, _toDisplayString(csvFileNamePreview.value), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (csvFileNamePreview.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_unref(messages).examInfo.errors)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(messages).examInfo.errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: "text-red-500 text-sm"
                                }, _toDisplayString(error), 1));
                            }), 128))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            disabled: isProcessing.value,
                            class: "py-2 px-6 bg-green-500 hover:shadow-lg text-white rounded disabled:bg-gray-400 disabled:cursor-not-allowed",
                            onClick: _withModifiers(onSubmitted, ["prevent"])
                        }, " ファイル読み込み実行 ", 8, _hoisted_21)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                        _hoisted_23,
                        (_unref(messages).schoolInfo.errors)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(messages).schoolInfo.errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("p", {
                                    key: index,
                                    class: "text-red-500 text-sm"
                                }, _toDisplayString(error), 1));
                            }), 128))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            disabled: isProcessing.value,
                            class: "py-2 px-12 bg-green-500 hover:shadow-lg text-white rounded disabled:bg-gray-400 disabled:cursor-not-allowed",
                            onClick: _withModifiers(onClickedSetScoreButton, ["prevent"])
                        }, " 集計 ", 8, _hoisted_24)
                    ])
                ]),
                (__props.registeredUserCount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 模試実施人数： " + _toDisplayString(props.registeredUserCount +
                        props.notExistentUsersData.length +
                        props.answerRegisteredUsersData.length +
                        props.sameIdUsersData.length +
                        props.notStudentUsersData.length) + "名 ", 1))
                    : _createCommentVNode("", true),
                (__props.registeredUserCount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 登録したユーザ： " + _toDisplayString(__props.registeredUserCount) + "名 ", 1))
                    : _createCommentVNode("", true),
                (__props.notExistentUsersData.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, " ユーザ情報が存在しないユーザ： " + _toDisplayString(__props.notExistentUsersData.length) + "名 ", 1),
                        _createElementVNode("button", _hoisted_29, [
                            _createVNode(_unref(DownloadCsv), {
                                data: _unref(getNotExistentUsersData),
                                labels: _unref(csvLabels),
                                name: _unref(NotExistentUserFileName)
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_30
                                ]),
                                _: 1
                            }, 8, ["data", "labels", "name"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (__props.answerRegisteredUsersData.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, " 解答情報登録済みのユーザ： " + _toDisplayString(__props.answerRegisteredUsersData.length) + "名 ", 1),
                        _createElementVNode("button", _hoisted_33, [
                            _createVNode(_unref(DownloadCsv), {
                                data: _unref(getAnswerRegisteredUsersData),
                                labels: _unref(csvLabels),
                                name: _unref(answerRegisteredUserFileName)
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_34
                                ]),
                                _: 1
                            }, 8, ["data", "labels", "name"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (__props.sameIdUsersData.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, " 同一なuserIDを持つユーザ： " + _toDisplayString(__props.sameIdUsersData.length) + "名 ", 1),
                        _createElementVNode("button", _hoisted_37, [
                            _createVNode(_unref(DownloadCsv), {
                                data: _unref(getSameIdUsersData),
                                labels: _unref(csvLabels),
                                name: _unref(sameIdUserFileName)
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_38
                                ]),
                                _: 1
                            }, 8, ["data", "labels", "name"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (__props.notStudentUsersData.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, " 連携済み学生ではないユーザ： " + _toDisplayString(__props.notStudentUsersData.length) + "名 ", 1),
                        _createElementVNode("button", _hoisted_41, [
                            _createVNode(_unref(DownloadCsv), {
                                data: _unref(getNotStudentUsersData),
                                labels: _unref(csvLabels),
                                name: _unref(notStudentUserFileName)
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_42
                                ]),
                                _: 1
                            }, 8, ["data", "labels", "name"])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
